import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { createReducer, User } from '@topconagriculture/frontend-utils';

import { createCompanyUser, getCompanyUserList } from './company.user.actions';

export type CompanyUserState = {
  readonly companyUserList: User[];
  readonly newUserId: string | null;
};

export enum UserRoles {
  ADMIN = 'Admin',
  STANDARD = 'Standart',
}

export type UserAppRole = { userCompanyRole: string; userRole: string };

export type UserPayload = {
  id?: string;
  companyId?: string;
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  locale: string;
  state: string;
  roles: UserRoles[];
  settings: {
    regionalSettingsName: string;
  };
};

export const initialState: CompanyUserState = {
  companyUserList: [],
  newUserId: null,
};

const companyUserReducer = createReducer(initialState, {
  [getCompanyUserList.done.type]: (state: CompanyUserState, action: Action<{ result: User[] }>) => {
    return dotProp.set(state, 'companyUserList', action.payload.result);
  },
  [createCompanyUser.done.type]: (state: CompanyUserState, action: Action<{ params: User; result: any }>) => {
    const { params: user, result } = action.payload;
    const newUser: User = { ...user, id: result.addUser.user.id };
    const newState: User[] = dotProp.get(state, 'companyUserList');
    return {
      newUserId: result.addUser.user.id,
      companyUserList: [...newState, newUser],
    };
  },
});

export default companyUserReducer;
